import AOS from 'aos';

let isInit = false;

const init = () => {
	if (isInit) {
		return;
	}

	AOS.refreshHard();

	AOS.init({
		delay: 100,
		once: true,
		offset: 150,
		duration: 700,
	});

	isInit = true;
};

export default {
	init,
};
